exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".attributes-container{max-height:18.75rem;overflow-y:visible;overflow-x:hidden}.margin-auto{margin:auto}div.hover-attribute{width:-webkit-max-content;width:-moz-max-content;width:max-content;max-width:200px}div .quote-item-content div.hover-attribute>span:not(.Select-arrow-zone){display:inline}.line-height-xs{line-height:1rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??ref--1-2!./node_modules/sass-loader/dist/cjs.js??ref--1-3!./src/quote/customAttributes/styles/styles.scss
// module id = 4453
// module chunks = 0